import { useLayoutEffect, useRef, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import Choices from 'choices.js';

function Select({
  onChange,
  multiple,
  disabled,
  className,
  placeholder,
  removeItemButton,
  shouldSort,
  searchEnabled,
  searchPlaceholder,
  value,
  children,
  id,
}) {
  const selectInput = useRef(null);
  const choicesRef = useRef(null);

  // ✅ 1. Initialize Choices.js only once
  useLayoutEffect(() => {
    if (!selectInput.current) return;

    choicesRef.current = new Choices(selectInput.current, {
      silent: true,
      allowHTML: false,
      searchEnabled: !!searchEnabled,
      placeholder: true,
      placeholderValue: placeholder || 'Select...',
      searchPlaceholderValue: searchPlaceholder || 'Search',
      shouldSort: !!shouldSort,
      removeItemButton: !!removeItemButton,
    });

    return () => {
      if (choicesRef.current) {
        choicesRef.current.destroy();
      }
    };
  }, []);

  // ✅ 2. Update selected values safely when `value` changes
  useEffect(() => {
    if (!selectInput.current || !value || !Array.isArray(value)) return;

    // Update selected values without triggering re-render
    Array.from(selectInput.current.options).forEach((option) => {
      option.selected = value.includes(option.value);
    });

    // Manually notify Choices.js
    if (choicesRef.current) {
      choicesRef.current.setChoiceByValue(value);
    }
  }, [value]);

  return (
    <Form.Select
      onChange={onChange}
      className={className}
      ref={selectInput}
      multiple={multiple}
      disabled={disabled}
      id={id}
    >
      {placeholder && <option value=''>{placeholder}</option>}
      {children}
    </Form.Select>
  );
}

export default Select;




// import {useLayoutEffect, useRef} from 'react'
// import { Form } from 'react-bootstrap';
// import Choices from 'choices.js';

// function Select({...props}) {

//   const {onChange,multiple, disabled, className, placeholder, removeItemButton, shouldSort, searchEnabled, searchPlaceholder, defaultValue} = props;

//   const selectInput = useRef(null);
//   useLayoutEffect( ()=> {
//     new Choices(selectInput.current, {
//       silent: true,
//       allowHTML: false,
//       searchEnabled: false || searchEnabled,
//       placeholder: true,
//       placeholderValue: placeholder,
//       searchPlaceholderValue: 'Search' || searchPlaceholder,
//       shouldSort: false || shouldSort,
//       removeItemButton: false || removeItemButton,
//     });
//   })

//   return (
//     <>
//       <Form.Select onChange={onChange} defaultValue={defaultValue} className={className} ref={selectInput} multiple={multiple} disabled={disabled}>
//         {placeholder && <option value=''>{placeholder}</option> }
//         {props.children}
//       </Form.Select>
//     </>
//   )
// }

// export default Select